import { Platform } from 'react-native';

import imagePaths from './image-path-helper';
import { helpers } from './helpers';

const getImagePath = (image) => {
  return (Platform.OS != "web" || helpers.isLocal) ? imagePaths[image] : helpers.staticEndpoint + '/' + image;
};

export default getImagePath